// extracted by mini-css-extract-plugin
module.exports = {"tableFooter":"TableFooter_tableFooter__1cXy1","button":"TableFooter_button__2OgkC","activeButton":"TableFooter_activeButton__1a08p"};